import "./modal.css";
import { React, useState, useEffect, useRef } from "react";
import { IoWarning } from "react-icons/io5";
import { useAppContext } from "../../Context/AppContext";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import sleep from "../Functions/sleep.jsx";

const DeleteModal = ({ isOpen, changeState, toDelete }) => {
  const { changes, setChanges, logout, token } = useAppContext();
  const [id, setId] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const messageRef = useRef(null);
  const modalRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (toDelete) setId(toDelete.id);
  }, toDelete);

  const handleSubmit = async (e) => {
    const url = process.env.REACT_APP_URL +  "api/menu/" + toDelete.id;

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        /// ok
        const data = await response.json();

        changeState(false);
        toast.success(data.message);
        setTimeout(() => {
          setChanges(changes + 1);
        }, 2000);
      } else {
        let messageError = "";

        if (response.statusText === "Unauthorized") {
          toast.error(
            "Por favor, inicia sesion para poder eliminar el producto.",
          );
          await sleep(1000);
          logout();
          navigate("/login");
          return;
        }
        switch (response.status) {
          case 400:
            messageError = "Seleccione el producto que quiere eliminar.";
            break;
          case 404:
            messageError =
              "No se encontro el producto que se quiere eliminar, actualice la pagina y vuelva a intentar.";
            break;
          case 500:
            messageError = "Error al procesar su solicitud.";
            break;
          default:
            messageError = "Error al eliminar el producto.";
            break;
        }

        throw new Error(messageError);
      }
    } catch (error) {
      changeState(false);
      toast.success(error.message);
    }
  };

  return (
    <div
      className={isOpen ? "modal-overlay" : "none-visibility"}
      onClick={() => changeState(false)}
    >
      <div ref={messageRef} className="status-message none-visibility">
        {statusMessage}
      </div>

      <div
        ref={modalRef}
        className="delete-modal modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="warning">
          <IoWarning className="warning-icon" />
        </div>

        <h1 className="modal-title">Eliminar Producto</h1>

        <div className="info-message">
          Eliminarás este producto para siempre, estas seguro que quieres borrar
          el producto ?
        </div>

        <div className="buttons-container">
          <button className="cancel-button" onClick={() => changeState(false)}>
            No, Cancelar.
          </button>
          <button className="delete-button" onClick={() => handleSubmit()}>
            Si , Eliminar!
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
